import { FamilyIcon } from '@repo/ui/icons'

import UserNavBar from '../../../components/elements/nav-bar'
import OlTeachingHallsListPage from '../../../components/pages/ols/teaching-halls/ol-teaching-halls'

const OLTeachingHallGlobalListPage = () => {
  return (
    <div>
      <UserNavBar title={'Teaching Halls'} icon={FamilyIcon} />
      <div className="h-4" />
      <OlTeachingHallsListPage mode="global" />
    </div>
  )
}

export default OLTeachingHallGlobalListPage
